const FACE_ID_KEY = "preferred_login_face_id";
const FACE_ID_ENABLED = "true";

export const enableFaceAuth = () => {
	localStorage.setItem(FACE_ID_KEY, FACE_ID_ENABLED);
};

export const disableFaceAuth = () => {
	localStorage.removeItem(FACE_ID_KEY);
};

export const isFaceAuthEnabled = (): boolean => {
	return localStorage.getItem(FACE_ID_KEY) === FACE_ID_ENABLED;
};
